module.exports = __webpack_public_path__ + "img/vanHouten.0880c12f.svg";